export const ultimasNoticias = [

  
  
    {
        "imagen" : "../Img/DENUNCIASEGOB.jpg",
        "url" : "",
        "titulo" : "DENUNCIA",
        "fecha" : "¿Necesitas Ayuda?"
    },

  




]